import React, {useEffect} from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { sendVote } from '../actions';

const Vote = props => {

  useEffect(() => {
    props.sendVote(props.urlParams.data);
  }, []);

  const {loading, error, errorMessage, data} = props.voteResult;

  if (loading) return <p>Sending vote...</p>;

  const renderResult = (msg) => {
    return (
      <div className='voteContainer'>
        <h2 className='vote-title'>Voting result</h2>
        <div className='vote-result'>{msg}</div>
      </div>
    );
  }

  if (error) return renderResult(errorMessage);

  return renderResult(data?.output);
}

Vote.propTypes = {
  sendVote: PropTypes.func.isRequired,
  urlParams: PropTypes.object,
  voteResult: PropTypes.object,
  loading: PropTypes.bool,
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
  data: PropTypes.string,
};

const mapStateToProps = state => {
   return {
    voteResult: state.resources.send_vote,
  };
};

export default connect(mapStateToProps, {
  sendVote,
})(Vote);
